var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3906 2.1875H21.875V0.875C21.875 0.391781 21.4833 0 21 0C20.5167 0 20.125 0.391781 20.125 0.875V2.1875H7.875V0.875C7.875 0.391781 7.48327 0 7 0C6.51673 0 6.125 0.391781 6.125 0.875V2.1875H3.60938C1.61913 2.1875 0 3.80663 0 5.79688V24.3906C0 26.3809 1.61913 28 3.60938 28H24.3906C26.3809 28 28 26.3809 28 24.3906V5.79688C28 3.80663 26.3809 2.1875 24.3906 2.1875ZM3.60938 3.9375H6.125V4.8125C6.125 5.29572 6.51673 5.6875 7 5.6875C7.48327 5.6875 7.875 5.29572 7.875 4.8125V3.9375H20.125V4.8125C20.125 5.29572 20.5167 5.6875 21 5.6875C21.4833 5.6875 21.875 5.29572 21.875 4.8125V3.9375H24.3906C25.4159 3.9375 26.25 4.77159 26.25 5.79688V7.875H1.75V5.79688C1.75 4.77159 2.58409 3.9375 3.60938 3.9375ZM24.3906 26.25H3.60938C2.58409 26.25 1.75 25.4159 1.75 24.3906V9.625H26.25V24.3906C26.25 25.4159 25.4159 26.25 24.3906 26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7544f8ae8d22e8b37e9efb6c35d3ba1c.svg";
export { ForwardRef as ReactComponent };